export default {
  title: 'Definir ícone',
  description: `O ícone do site (ou Favicon) é um pequeno logotipo, que aparece
                geralmente na barra de endereços do navegador, antes do nome do site`
}
